/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { MENTIONS: de },
  'el-GR': { MENTIONS: el },
  'en-US': { MENTIONS: en },
  'es-ES': { MENTIONS: es },
  'fi-FI': { MENTIONS: fi },
  'fr-FR': { MENTIONS: fr },
  'it-IT': { MENTIONS: it },
  'pl-PL': { MENTIONS: pl },
  'pt-PT': { MENTIONS: pt }
};
